import { useMutation } from '@tanstack/react-query';
import { useRouter } from 'next/router';

import { $apiV2, errorHandler, globalConst } from 'modules/global';

export const useOrderTest = () => {
  const { push } = useRouter();

  return useMutation({
    mutationFn: async (requestData: { language_id?: number; year_id?: number; collection_id?: number }) => {
      const { data } = await $apiV2.post('/dtm/order', requestData);

      return data;
    },
    onSuccess: () => {
      push(globalConst.pageNames.DTM_TEST);
    },
    onError: errorHandler()
  });
};
